import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const ParameterPanel = ({ onExport, onSchedule }) => {
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [selectedBuyer, setSelectedBuyer] = useState('');
  const [exportFormat, setExportFormat] = useState('pdf');

  const supplierOptions = [
    { value: 'all', label: 'All Suppliers' },
    { value: 'whitehaven', label: 'Whitehaven Coal' },
    { value: 'yancoal', label: 'Yancoal Australia' },
    { value: 'glencore', label: 'Glencore Coal Assets' },
  ];

  const buyerOptions = [
    { value: 'all', label: 'All Buyers' },
    { value: 'adani', label: 'Adani Power' },
    { value: 'ntpc', label: 'NTPC Limited' },
    { value: 'tata', label: 'Tata Power' },
  ];

  const exportFormatOptions = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'csv', label: 'CSV File' },
  ];

  return (
    <div className="h-full flex flex-col bg-card border-l border-border">
      <div className="p-4 border-b border-border">
        <h3 className="font-semibold text-foreground flex items-center gap-2">
          <Icon name="Settings" size={20} />
          Report Parameters
        </h3>
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-6">
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3">Date Range</h4>
          <div className="space-y-3">
            <Input
              type="date"
              label="Start Date"
              value={dateRange?.start}
              onChange={(e) => setDateRange({ ...dateRange, start: e?.target?.value })}
            />
            <Input
              type="date"
              label="End Date"
              value={dateRange?.end}
              onChange={(e) => setDateRange({ ...dateRange, end: e?.target?.value })}
            />
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3">Filters</h4>
          <div className="space-y-3">
            <Select
              label="Supplier"
              options={supplierOptions}
              value={selectedSupplier}
              onChange={setSelectedSupplier}
              placeholder="Select supplier"
            />
            <Select
              label="Buyer"
              options={buyerOptions}
              value={selectedBuyer}
              onChange={setSelectedBuyer}
              placeholder="Select buyer"
            />
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3">Data Options</h4>
          <div className="space-y-2">
            <Checkbox label="Include cost breakdown" />
            <Checkbox label="Show fee calculations" />
            <Checkbox label="Display issue summary" />
            <Checkbox label="Include vessel details" />
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3">Export Format</h4>
          <Select
            options={exportFormatOptions}
            value={exportFormat}
            onChange={setExportFormat}
          />
        </div>
      </div>
      <div className="p-4 border-t border-border space-y-2">
        <Button
          variant="default"
          fullWidth
          iconName="Download"
          onClick={() => onExport(exportFormat)}
        >
          Export Report
        </Button>
        <Button
          variant="outline"
          fullWidth
          iconName="Calendar"
          onClick={onSchedule}
        >
          Schedule Report
        </Button>
      </div>
    </div>
  );
};

export default ParameterPanel;